(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("i18n/en-ie", [], factory);
	else if(typeof exports === 'object')
		exports["i18n/en-ie"] = factory();
	else
		root["i18n/en-ie"] = factory();
})(window, function() {
return 